export default "__VITE_ASSET__b22af367__"